<template>
  <div class="summary-bar">
    <dl class="summary-facts">
      <div class="summary-fact">
        <dt class="summary-fact-label">Vehículo</dt>
        <dd class="summary-fact-value" :title="vehicleLabel">{{ vehicleLabel }}</dd>
        <button type="button" class="summary-edit" @click="emit('edit-vehicle')">Editar</button>
      </div>
      <div class="summary-fact">
        <dt class="summary-fact-label">Conductor</dt>
        <dd class="summary-fact-value" :title="driverLabel">{{ driverLabel }}</dd>
        <button type="button" class="summary-edit" @click="emit('edit-driver')">Editar</button>
      </div>
    </dl>

    <div v-if="canShareOrDownload" class="summary-actions">
      <el-button
        v-if="SHOW_EMAIL_SHARE"
        class="summary-action"
        :loading="isSendingEmail"
        @click="emit('send-email')"
      >
        <el-icon><Message /></el-icon>
        <span>{{ isSendingEmail ? 'Enviando...' : 'Correo' }}</span>
      </el-button>
      <el-button
        v-if="SHOW_WHATSAPP_SHARE"
        class="summary-action"
        :loading="isSendingWhatsApp"
        @click="emit('send-whatsapp')"
      >
        <el-icon><ChatDotRound /></el-icon>
        <span>{{ isSendingWhatsApp ? 'Enviando...' : 'WhatsApp' }}</span>
      </el-button>
      <el-button class="summary-action" :loading="isDownloading" @click="emit('download')">
        <el-icon><Download /></el-icon>
        <span>{{ isDownloading ? 'Descargando...' : 'PDF' }}</span>
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ChatDotRound, Download, Message } from '@element-plus/icons-vue';
import { SHOW_EMAIL_SHARE, SHOW_WHATSAPP_SHARE } from '@/config/features';
import type { QuoteData } from '@/types/quote.types';

interface Props {
  quoteData: QuoteData;
  isSendingEmail: boolean;
  isSendingWhatsApp?: boolean;
  isDownloading: boolean;
  canShareOrDownload?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isSendingWhatsApp: false,
  canShareOrDownload: true,
});

const emit = defineEmits<{
  'edit-vehicle': [];
  'edit-driver': [];
  'send-email': [];
  'send-whatsapp': [];
  download: [];
}>();

const joinFilled = (parts: Array<string | number | undefined | null>): string =>
  parts.filter((part) => part !== undefined && part !== null && part !== '').join(' · ') || '-';

const vehicleLabel = computed(() =>
  joinFilled([props.quoteData.year, props.quoteData.brand?.name, props.quoteData.type]),
);

const driverLabel = computed(() => {
  const personal = props.quoteData.personalData;
  return joinFilled([personal?.fullName, personal?.postalCode ? `CP ${personal.postalCode}` : null]);
});
</script>
